import React, { FC } from 'react';
import { TMenuLinksValues } from './SubHeader/constants/menuLinks';

type TProps = {
  id: TMenuLinksValues | 'block-buttons';
};

export const NavigationFakeDiv: FC<TProps> = ({ id }) => {
  const header = document.getElementById('page-header');
  const headerHeight = header?.getBoundingClientRect()?.height || 0;

  return <div id={id} style={{ position: 'absolute', top: -headerHeight }} />;
};
